/* eslint-disable camelcase */
import 'bootstrap/dist/css/bootstrap.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { loadMessages, locale } from 'devextreme/localization';
import ptMessages from 'devextreme/localization/messages/pt.json';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.css';
import pt_BR from 'rsuite/lib/IntlProvider/locales/pt_BR';
import App from './App';
import store from './store/Store';

loadMessages(ptMessages);
locale('pt');

ReactDOM.render(
  <IntlProvider locale={pt_BR}>
    <Provider store={store}>
      <App />
    </Provider>
  </IntlProvider>,
  document.getElementById('root')
);
